// extracted by mini-css-extract-plugin
module.exports = {"header":"LambTableHeadAnother_header__2W7mm","row":"LambTableHeadAnother_row__2gl-S"};